import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { useLocation } from 'react-router-dom';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState, parseData } from './config';

import Sidebar from './Components/Sidebar';


const EditPayment = () => {
  const location = useLocation();

  const state = location.state;

  console.log(location, state, "state");

  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);
  const [initValues, setInitValues] = useState(initialValues);

  useEffect(() => {
    if (state?.customer_id) {
      console.log(state, "state");
      setFormFields(ofv => {
        return ofv.map(field => {
          if (field.name === "customer_id") {
            return { ...field, serverOptions: [{ customer_id: state.customer_id, full_name: state.client_name, mobile_phone: state.mobile_phone, email: state.email }], disabled: true };
          }
          return field;
        });
      });

      setInitValues(oiv => {
        return { ...oiv, customer_id: state.customer_id, client_name: state.client_name };
      });
    }
  }, [state?.customer_id]);

  console.log(formFields, "formFields");

  return (
    <EditForm title={"Payment"} initialValues={initValues} fields={formFields} schema={schema} url={"payments"} additionalState={additionalState} sidebar={<Sidebar />} parseData={parseData}>
      
     </EditForm>
  );
}

export default EditPayment;